import { Controller } from '@hotwired/stimulus'

const FILTER_FIELD_NAMES = [
  'references_search[gesture_id]',
  'references_search[service_id]',
  'references_search[query]'
]

export default class extends Controller {
  static targets = ['button']
  static values = { exportPath: String }

  connect () {
    this.toggle()
  }

  toggle () {
    if (!this.hasButtonTarget) return

    this.buttonTarget.disabled = !this.anyTeamSelected()
    this.syncExportPath()
  }

  export () {
    if (!this.hasButtonTarget || this.buttonTarget.disabled) return

    this.syncExportPath()
    const url = new URL(this.exportPathValue, window.location.origin)
    this.selectedTeamIds().forEach((id) => url.searchParams.append('team_ids[]', id))
    window.location.assign(url.toString())
  }

  anyTeamSelected () {
    return this.selectedTeamIds().length > 0
  }

  selectedTeamIds () {
    const field = document.querySelector('input[name="references_search[team_ids]"]')
    if (!field || !field.value) return []

    return field.value.split(',').filter(Boolean)
  }

  // The server-rendered path only updates after the debounced Turbo refresh.
  // Read live filter fields so gesture/service/query are not dropped in between.
  syncExportPath () {
    const url = new URL(this.exportPathValue, window.location.origin)
    const staleKeys = []
    url.searchParams.forEach((_value, key) => {
      if (key.startsWith('references_search[')) staleKeys.push(key)
    })
    staleKeys.forEach((key) => url.searchParams.delete(key))

    FILTER_FIELD_NAMES.forEach((name) => {
      const field = document.querySelector(`[name="${name}"]`)
      if (!field) return

      url.searchParams.set(name, field.value)
    })

    this.exportPathValue = `${url.pathname}${url.search}`
  }
}
